<template>
    <div>
        <div class="col-md-12 mx-auto">
            <!--<div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="redirectToList">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>-->
            <participant-edit :id="id"
                              :details="details">
            </participant-edit>
        </div>
    </div>
</template>

<script>
    import ParticipantEdit from "../../components/participants/ParticipantEdit";

    export default {
        components: {
            ParticipantEdit
        },
        props: {
            id: {
                type: [Number, String],
                required: true
            },
            details: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
            }
        },
        methods: {

        }
    }
</script>
